/**
 * Lists of actions that can be triggered from signs using the iframe messenger
 */
enum PlayerActions {
    PLAYER_ACTION = 'PLAYER_ACTION',
    GET_SCREENSHOT = 'GET_SCREENSHOT',
    GET_PLAYER_VERSION = 'GET_PLAYER_VERSION',
    GET_NAMED_VALUE = 'GET_NAMED_VALUE',
    SET_NAMED_VALUE = 'SET_NAMED_VALUE',
    DELETE_NAMED_VALUE = 'DELETE_NAMED_VALUE',
    CONFIG_KEY_EXISTS = 'CONFIG_KEY_EXISTS',
    GET_NETWORK_STATUS = 'GET_NETWORK_STATUS',
    GET_DEVICE_INFORMATION = 'GET_DEVICE_INFORMATION',
    SET_LOG_LEVEL = 'SET_LOG_LEVEL',
    SET_LOG_LEVEL_INFO = 'SET_LOG_LEVEL_INFO',
    SET_LOG_LEVEL_WARN = 'SET_LOG_LEVEL_WARN',
    SET_LOG_LEVEL_ERROR = 'SET_LOG_LEVEL_ERROR',
    SET_LOG_LEVEL_DEBUG = 'SET_LOG_LEVEL_DEBUG',
    ENABLE_PERSISTENT_CONSOLE_LOG = 'ENABLE_PERSISTENT_CONSOLE_LOG',
    DISABLE_PERSISTENT_CONSOLE_LOG = 'DISABLE_PERSISTENT_CONSOLE_LOG',
    ENABLE_PERSISTENT_FILE_LOG = 'ENABLE_PERSISTENT_FILE_LOG',
    DISABLE_PERSISTENT_FILE_LOG = 'DISABLE_PERSISTENT_FILE_LOG',
    GET_LOGS = 'GET_LOGS',
    DELETE_LOGS = 'DELETE_LOGS',
    NO_SCHEDULED_CONTENT = 'NO_SCHEDULED_CONTENT',
    TOGGLE_SETTINGS_OVERLAY = 'TOGGLE_SETTINGS_OVERLAY',
    APPLICATION_RESTART = 'APPLICATION_RESTART',
}

export default PlayerActions;
